<template>
    <div>
        <div class="d-flex mb-2">
            <div class="flex-fill member-search-area">
                <div class="d-flex search-text-area">
                    <div class="input-container">
                        <input
                            type="text"
                            @input="isTyping = true"
                            v-model="keyword"
                            class="form-control input-search"
                            placeholder="Search for an admin for the organisation"
                        />
                        <button
                            v-if="keyword"
                            @click="clearInput"
                            class="clear-button"
                        >×</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="pb-2">
            Users returned in the search belong to companies assigned to this organisation
        </div>

        <div class="scrollable-panel">
            <div class="row match-height">
                <div
                    class="col-lg-12 col-md-12 col-sm-12"
                    v-for="(user, index) in users"
                    :key="index"
                >
                    <organisation-admin-directory-card
                        :organisation-id="organisationId"
                        :plan-id="planId"
                        :user="user"
                        :organisation-admin="organisationAdmin"
                        :index="index"
                        @update-organisation-admin="handleUpdateOrganisationAdmin"
                    />
                </div>
            </div>

            <infinite-loading
                spinner="spiral"
                :identifier="infiniteId"
                @distance="1"
                @infinite="infiniteHandler"
            >
                <template #no-more>
                    <div class="text-center py-2">No more users</div>
                </template>
                <template #no-results>
                    <div class="text-center py-2">No results found</div>
                </template>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import OrganisationAdminDirectoryCard from './OrganisationAdminDirectoryCard.vue';

export default {
    name: 'OrganisationAdminList',

    components: {
        InfiniteLoading,
        OrganisationAdminDirectoryCard,
    },

    props: {
        organisationId: {
            type: Number,
            required: true,
            validator: v => Number.isInteger(v),
        },
        organisationAdmin: {
            type: Number,
            required: false,
            default: null,
            validator: v => v === null || Number.isInteger(v),
        },
        planId: {
            type: Number,
            required: true,
            validator: v => Number.isInteger(v),
        },
    },

    data() {
        return {
            users: [],
            page: 1,
            keyword: '',
            infiniteId: Date.now(),
            isTyping: false,
        };
    },

    created() {
        console.log('✅ OrganisationAdminList created – props:', {
            organisationId: this.organisationId,
            planId: this.planId,
            organisationAdmin: this.organisationAdmin,
        });
        console.log(
            '🔧 Globals:',
            'axios=' + typeof axios,
            '_=' + typeof _,
            '$=' + typeof $
        );
    },

    mounted() {
        console.log('🟢 OrganisationAdminList mounted – starting first load');
        this.infiniteHandler({ loaded: () => {}, complete: () => {} });
    },

    methods: {
        infiniteHandler($state) {
            this.loadCompaniesUsers($state);
        },

        loadCompaniesUsers($state) {
            if (typeof axios !== 'function') {
                console.error('✋ axios is not available');
                return;
            }

            const url = `/admin/organisation-management/assign-admin/${this.organisationId}?page=${this.page}`;
            axios
                .post(url, { keyword: this.keyword })
                .then(response => {
                    const results = response.data.data || [];
                    if (results.length > 0) {
                        results.forEach(item => this.users.push(item));
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                })
                .catch(err => {
                    console.error('❌ Error loading users:', err);
                    $state.complete();
                });

            this.page++;
        },

        clearInput() {
            this.keyword = '';
            this.isTyping = false;
        },

        handleUpdateOrganisationAdmin(memberId) {
            this.organisationAdmin = memberId;
        },
    },

    watch: {
        keyword: _.debounce(function () {
            this.isTyping = false;
            this.page = 1;
            this.users = [];
            this.infiniteId = Date.now();
        }, 1500),

        isTyping(value) {
            if (!value) {
                this.infiniteHandler({ loaded: () => {}, complete: () => {} });
            }
        },
    },
};
</script>

<style scoped>
.input-search {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.scrollable-panel {
    max-height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
}

.scrollable-panel::-webkit-scrollbar {
    width: 5px;
}

.scrollable-panel::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
}

.input-container {
    position: relative;
    width: 100%;
}

.clear-button {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    color: #aaa;
}

.clear-button:hover {
    color: #000;
}
</style>
